/** 가공·시공 부자재 제조사 세분류 code (sessionUser.gclientType04docus) */
export const SUB_MAT_MANUFACTURER_CODES = [
  'MANUFACTURER_SUB_MATERIAL_PROCESS',
  'MANUFACTURER_SUB_MATERIAL_BUILD',
];

/** 부자재 전용 GCLIENT에서 숨길 메뉴 id */
export const SUBMAT_ONLY_HIDDEN_MENU_IDS = [
  'g04docu_generate_file',
  'g04docu_generate_file_new',
  'g04docu_material_approval',
  'g04docu_files',
  'g04docu_search',
];

/**
 * 비부자재 GCLIENT에서 숨길 메뉴 id.
 * 폴더형(New) 메뉴는 원판·가공에도 노출하므로 비워 둔다.
 */
export const NON_SUBMAT_HIDDEN_MENU_IDS = [];

const PATH_TO_MENU_ID = {
  '/g04docuSubMatTemplate': 'g04docu_submat_template',
  '/g04docuGenerateFile': 'g04docu_generate_file',
  '/g04docuGenerateFileNew': 'g04docu_generate_file_new',
  '/g04docuMaterialApproval': 'g04docu_material_approval',
  '/g04docuFiles': 'g04docu_files',
  '/g04docuSubMatFolders': 'g04docu_submat_folders',
  '/g04docuSubMatSend': 'g04docu_submat_send',
  '/g04docuSubMatExpiryReview': 'g04docu_submat_expiry_review',
  '/g04docuSearch': 'g04docu_search',
  '/g04docuAlarmSettings': 'g04docu_alarm_settings',
};

export const getGClientType04docuCodes = (sessionUser) => {
  const list = sessionUser?.gclientType04docus;
  if (!list || !Array.isArray(list)) return [];
  return list.map((t) => t?.code).filter(Boolean);
};

export const hasSubMatManufacturer = (sessionUser) => {
  const codes = getGClientType04docuCodes(sessionUser);
  return SUB_MAT_MANUFACTURER_CODES.some((c) => codes.includes(c));
};

/** 세분류가 부자재 제조사 code만 있는 경우 */
export const isSubMatOnlyCompany = (sessionUser) => {
  const codes = getGClientType04docuCodes(sessionUser);
  if (codes.length === 0) return false;
  return codes.every((c) => SUB_MAT_MANUFACTURER_CODES.includes(c));
};

/**
 * GCLIENT 회사 프로필 (메뉴·라우트 필터용)
 * - submat_only: 부자재 세분류만
 * - mixed: 부자재 + 기타 세분류
 * - non_submat: 부자재 세분류 없음
 * - default: ADMIN·USER·KFGWA 등 필터 미적용
 */
export const getSubMatMenuProfile = (sessionUser) => {
  if (!sessionUser || sessionUser.type !== 'GCLIENT') {
    return 'default';
  }
  if (sessionUser.bizRegNumber === '220-82-07388') {
    return 'default';
  }
  if (isSubMatOnlyCompany(sessionUser)) return 'submat_only';
  if (hasSubMatManufacturer(sessionUser)) return 'mixed';
  return 'non_submat';
};

export const shouldHideMenuBySubMatProfile = (menuId, profile) => {
  if (!menuId || profile === 'default' || profile === 'mixed') return false;
  if (profile === 'submat_only') {
    return SUBMAT_ONLY_HIDDEN_MENU_IDS.includes(menuId);
  }
  if (profile === 'non_submat') {
    return NON_SUBMAT_HIDDEN_MENU_IDS.includes(menuId);
  }
  return false;
};

export const isSubMatRouteAllowed = (sessionUser, path) => {
  const menuId = PATH_TO_MENU_ID[path];
  if (!menuId) return true;
  const profile = getSubMatMenuProfile(sessionUser);
  return !shouldHideMenuBySubMatProfile(menuId, profile);
};

/** 폴더형 서류보내기도 전송바구니를 쓰므로 부자재 전용 회사에도 바구니를 보여 준다. */
export const shouldShowSendBasket = (_sessionUser) => true;
